var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/crown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4662 19.6619H7.45782C7.05532 19.6619 6.6049 19.3456 6.47073 18.9623L2.50323 7.86479C1.93782 6.27396 2.59907 5.78521 3.9599 6.76271L7.6974 9.43646C8.32032 9.86771 9.02948 9.64729 9.29782 8.94771L10.9845 4.45312C11.5211 3.01562 12.4124 3.01562 12.9491 4.45312L14.6357 8.94771C14.9041 9.64729 15.6132 9.86771 16.2266 9.43646L19.7341 6.93521C21.2291 5.86188 21.9478 6.40813 21.3345 8.14271L17.4628 18.9815C17.3191 19.3456 16.8687 19.6619 16.4662 19.6619Z",
    fill: "#EA582B",
    stroke: "#EA582B",
    strokeWidth: 1.725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.4dfbb4da8bb0a8216b959f5ed1c11492.svg";
export { ForwardRef as ReactComponent };